import { render, staticRenderFns } from "./PAYGDowngradeButton.vue?vue&type=template&id=c99082f0&"
import script from "./PAYGDowngradeButton.vue?vue&type=script&lang=js&"
export * from "./PAYGDowngradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports